<template>
  <div>
    <span>Template for this item update audit comment is not yet implemented</span>
    <div>{{ comment.itemAuditRecord?.fieldName }}</div>
  </div>
</template>

<script setup lang="ts">
import { Comment } from "@/models"

defineProps<{
  comment: Comment
}>()
</script>
